import { ACTIVITY_TYPE, NOTIFICATION_EVENT_TYPE } from 'src/shared/config/src';
import LocalImages from '../static/index';

export const API_URL = process.env.REACT_APP_API_BASE_URL;
export const ACTIVE_BACKGROUND_TIMEOUT = 1800000;  // 30 minutes
export const DEFAULT_BRAND_COLOR = '#4AD0B0';
export const FCM_TOKEN_UPDATE_TIMEOUT = 604800000;   // 7 days
export const GENERAL_ERROR_MESSAGE = 'Something went wrong. Please try again later.';

export const NOTIFICATION_REMIND_LATER_TIMEOUT = 86400000;  // 1 day

export const DISABLE_EMAIL_NOTIFICATION_REMIND_LATER_TIMEOUT = 2592000000;  // 30 days

export const REPLY_MESSAGE_SEPARATOR_DASHES = '-------------------------';

export const URL_CONSTANTS = {
    FROM: 'from',
    ACTIVITY_TYPE: 'acitivity_type',
    TO: 'to',
    REDIRECT_TO: 'redirectTo',
    DATE: 'date',
    FUTURE_EVENTS: 'futureEvents'
}

export const DISABLE_INPUT_ACCESSORY_VIEW = 'disableInputAccessoryView';    // NOTE: THIS VALUE SHOULD NOT BE CHANGED, (IT MUST BE SAME AS CONSTANT DEFINED IN NATIVE IOS CODE)

export const SIGNATURE_TYPE = {
    SIGN: 'sign',
    BODY: 'body',
}

export const RESEND_TIME = 59

export const playStoreLink = "https://play.google.com/store/apps/details?id=com.eyLog.parentApp&pcampaignid=web_share";

export const AppMessages = {
    pleaseSelectChildToProceedForSignInOut: '👶 Please select a child to continue with Sign-In or Sign-Out.',
    youCannotSelectThisChildForSignIn: '⚠️ This child cannot be signed in.',
    youCannotSelectThisChildForSignOut: '⚠️ This child cannot be signed out.',
    thisQRCodeIsNotValid: '❌ Oops! This QR code is not valid.',
    failedToScanTheQRCode: '📸 Scan failed! Please try again.',
    signInOutCannotHappenAtTheSameTime: '⚠️ You cannot sign in and sign out at the same time.',
    youCannotSelectThisInactiveChildForSignInOut: '🚫 This child is inactive and cannot be signed in or out.',
    noInternetMessage: '📶 No internet connection. Please check your network.',
    noCommunicationsData: '📢 You haven’t received any communication from the nursery. Stay tuned! 😊',
    noConversationData: '💬 No conversations yet! Tap the ✏️ icon to start chatting with the nursery.',
    noInboxData: '📭 No messages yet! The nursery hasn’t sent you any messages. Stay tuned! 😊',
    noSentboxData: '📩 No sent messages. Use the ✏️ icon to send a message to your childcare provider.',
    emptyManagementTeam: 'Your childcare provider has not set up any users on the system yet to receive conversations. Please get in touch with them to start using this feature.',
    invalidTfcCodeFormat: 'Invalid TFC reference code',
    tfcCodesNotProvided: 'TFC Reference codes are not entered or are invalid.'
}

export const appStoreLink = "https://apps.apple.com/in/app/eyparent/id976010368";

export const WEBVIEW_SOURCE = {
    INVOICE: 'invoice',
    EYMEMORIES: 'eymemories'
}

export const MessageImageName = {
    mail: 'mail',
    // TODO: - Need to map these images with actual image keys
    message: 'message',
    announcement: 'announcement',
    groupConversation: 'icon-group-conversation',
}

export const MessageImages = new Map([
    [MessageImageName.mail, LocalImages.mailIconLight],
    [MessageImageName.message, LocalImages.messageIconLight],
    [MessageImageName.announcement, LocalImages.messageIconLight],
    [MessageImageName.groupConversation, LocalImages.groupConversationLight],
]);

export const MessageImagesDark = new Map([
    [MessageImageName.mail, LocalImages.mailIconDark],
    [MessageImageName.message, LocalImages.messageGroupDark],
    [MessageImageName.announcement, LocalImages.messageGroupDark],
    [MessageImageName.groupConversation, LocalImages.groupConversationDark],
]);

export const CONVERSATION_POLL_TIMEOUT = 10 * 1000; // 10 sec

export const ActivityFilterList: Array<{ key: string, label: string, iconName: keyof typeof LocalImages }> = [
    {
        key: ACTIVITY_TYPE.OBSERVATION,
        label: 'Observations',
        iconName: 'observationCardIcon',
    },
    {
        key: ACTIVITY_TYPE.DAILY_DIARY,
        label: 'Daily Diaries',
        iconName: 'dailyDiaryIcon',
    },
    {
        key: ACTIVITY_TYPE.ACCIDENT_SHEET,
        label: 'Accident/Incident Sheets',
        iconName: 'accidentSheetCardIcon',
    },
    {
        key: ACTIVITY_TYPE.MEDICINE_FORM,
        label: 'Medicine Forms',
        iconName: 'medicineFormIcon',
    },
    {
        key: ACTIVITY_TYPE.REPORTS,
        label: 'Reports',
        iconName: 'reportIcon',
    }
];

export const BOTTOM_TAB_BAR_HEIGHT = 55;

export const DEVICE_ID_KEY = 'EYPARENT_UDID';

export const FIRST_LAUNCH_KEY = 'EYPARENT_APP_FIRST_LAUNCH';

export const STORE_LINKS = {
    'android': 'https://play.google.com/store/apps/details?id=com.eyLog.parentApp',
    'ios': 'https://apps.apple.com/in/app/eyparent/id976010368'
}

export const DEFAULT_RETRY_TIMEOUT = 120;  // retry after 60 seconds

export const PAYMENT_METHODS = {
    TAX_FREE_CHILDCARE: 'TFC',
    STRIPE: 'STRIPE',
    WORLDPAY: 'WORLDPAY',
    OPAYO: 'OPAYO',
    DIRECTDEBIT: 'DIRECTDEBIT',
    DD_GOCARDLESS: 'DD_GOCARDLESS'
}

export const PAYMENT_METHOD_IMAGES = {
    [PAYMENT_METHODS.TAX_FREE_CHILDCARE]: LocalImages.taxFreeChildcareLight,
    [PAYMENT_METHODS.STRIPE]: LocalImages.stripeIcon,
    [PAYMENT_METHODS.WORLDPAY]: LocalImages.worldPayLogoIcon,
    [PAYMENT_METHODS.OPAYO]: LocalImages.opayoIcon,
    [PAYMENT_METHODS.DIRECTDEBIT]: LocalImages.directDebit,
    [PAYMENT_METHODS.DD_GOCARDLESS]: LocalImages.directDebit
}

export const PAYMENT_METHOD_IMAGES_DARK = {
    [PAYMENT_METHODS.TAX_FREE_CHILDCARE]: LocalImages.taxFreeChildcareDark,
    [PAYMENT_METHODS.STRIPE]: LocalImages.stripeIcon,
    [PAYMENT_METHODS.WORLDPAY]: LocalImages.worldPayLogoIcon,
    [PAYMENT_METHODS.OPAYO]: LocalImages.opayoIcon,
    [PAYMENT_METHODS.DIRECTDEBIT]: LocalImages.directDebit,
    [PAYMENT_METHODS.DD_GOCARDLESS]: LocalImages.directDebit
}

export const PAYMENT_METHOD_STATUS = {
    LINKED: 'LINKED',
    NOT_LINKED: 'NOT_LINKED',
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE'
}

// export const TFC_CODE_PATTERN = /^[A-Za-z]{4}\d{5}$/;

export const TFC_CODE_PATTERN = /^[a-zA-Z]{2}[a-zA-Z'.\- 0]{2}[0-9]{5}TFC$/;

export const HMRC_CALLBACK_URL = 'parent-app/user/tfc/hmrc-callback';
export const ERROR_SUBSTRING = 'error_code=USER_DENIED_AUTHORIZATION';
export const SUCCESS_SUBSTRING = '?code=';

export const HMRC_TOP_UP_LINK = 'https://www.gov.uk/sign-in-childcare-account';

export const HMRC_AUTH_EXPIRED_MSG = 'Your HMRC authorisation has expired. Please re-authorize to continue payments via this method.'
export const HMRC_CONFIRM_TOPUP_MESSAGE = 'You will be redirected to the HMRC login page to top up funds in your HMRC account.\nDo you wish to continue?';
export const HMRC_AUTH_VALID_CHILD_NOT_LINKED_MESSAGE = 'Your child is not linked to a Tax-Free Childcare account. To make payments via this method, please link to your Tax-Free Childcare account';
export const HMRC_PAYMENT_CONFIRMATION = '#AMOUNT# will be deducted from your TFC balance. Do you want to continue?';
export const HMRC_UNLINK_CHILD_CONFIRM = `This action will unlink the child's Tax-Free Childcare account. Do you want to continue?`;

export const GLOBAL_NOTIFICATION_TYPES = [NOTIFICATION_EVENT_TYPE.EYMEMORIES_DISCOUNT, NOTIFICATION_EVENT_TYPE.GENERAL_WEBLINK];

export const CAPCHA_SITE_KEY = process.env.REACT_APP_CAPCHA_SITE_KEY || '';